import { type Viewport } from '@xyflow/react';

import { getVisibleReactFlowPaneScreenSize } from './getVisibleReactFlowPaneScreenSize';
import { type FlowRect } from './viewportVisibility';

/**
 * Computes the visible region in flow-space coordinates given a `viewport`,
 * without requiring that viewport to be the currently applied one. Use the
 * current viewport via `getViewport()` from `useReactFlow` to inspect the
 * present state, or pass any other viewport to ask "what would I see if I
 * applied this?". In non-fullscreen mode the chat sidebar floats over the
 * canvas, so the container width is reduced by `CHAT_SIDEBAR_WIDTH_CSS_VAR`.
 */
export const getEffectiveViewportRect = (viewport: Viewport): FlowRect | undefined => {
  const paneSize = getVisibleReactFlowPaneScreenSize();

  if (!paneSize) {
    return undefined;
  }

  return {
    height: paneSize.height / viewport.zoom,
    width: paneSize.width / viewport.zoom,
    x: -viewport.x / viewport.zoom,
    y: -viewport.y / viewport.zoom,
  };
};
